export default {
  logoTitle: '卖家中心',
  home: '首页',
  loginOut: '退出登录',
  footer: 'Kilimall e-Commerce Cloud ',
  // ---------
  subMenuListName2: '仓库设置',
  subMenuListName3: '新增商品',
  subMenuListName4: '管理商品',
  subMenuListName5: '店铺自定义品类',
  subMenuListName6: '批量导入商品',
  subMenuListName7: '商品评价',
  subMenuListName8: '商品批量扩展',
  subMenuListName9: '管理订单',
  subMenuListName10: '订单发运',
  subMenuListName11: '自配送设置 ',
  subMenuListName12: '管理我的店铺',
  subMenuListName13: '店铺设置',
  subMenuListName14: '管理主帐号',
  subMenuListName15: '管理店员帐号',
  subMenuListName16: '开发者信息',
  subMenuListName17: '管理代金券模版',
  subMenuListName18: '管理代金券批次',
  subMenuListName19: '管理代金券',
  subMenuListName20: '闪购(秒杀)申请',
  subMenuListName21: '管理秒杀商品',
  subMenuListName22: 'TD(限时折扣)报名',
  subMenuListName23: '管理限时折扣商品',
  subMenuListName24: '对话消息',
  subMenuListName25: '管理平台积分计划',
  subMenuListName26: '店铺推荐商品',
  subMenuListName27: '管理满减活动商品',
  subMenuListName28: '售后管理',
  subMenuListName29: '清结算 (测试)',
  subMenuListName30: '活动报名',
  subMenuListName31: '管理团购商品',
  subMenuListName32: '管理大促活动商品',
  subMenuListName33: '系统消息',
  subMenuListName36: '违规处罚记录', // S331
  subMenuListName37: '平台物流账号配置',
  shopNews39: '系统公告',
  applyUseWarehouseTitle: '管理仓库授权',
  subMenuListName44: '管理备货商品库存',
  subMenuListName45: '商品级运费设置',
  subMenuListName46: '店铺级运费设置',
  subMenuListName47: '客户即时聊天',
  subMenuListName51: '赠品配置',
  subMenuListName52: '赠品管理',
  scrapListName: '商品报废申请记录',
  returnListName: '商品退仓申请记录',
  // -----------
  menu2: '商品',
  menu3: '订单',
  menu4: '服务',
  menu5: '备货',
  menu6: '促销',
  insights: '洞察',
  menu8: '财务',
  menu9: '店铺设置',
  menu10: '商户设置',
  menu11: '促销活动',
  menu12: '物流与仓库',
  //
  userName: '未知名称',
  logisticsHeadAccount: '物流帐户充值',
  logisticsCostSheets: '物流计费单据',
  restockInvitations: '邀请备货计划',
  reviewList: '商品评论',
  helpCenter: '帮助中心',
  sellerUniversity: '卖家大学',
  loginNewSeller: '去老卖家中心',
  transactionOrderNo: '交易订单号',
  logisticsOrderNo: '物流运单号',
  countryCode: '目的国',
  storeId: '店铺 ID',
  feeType: '费用类型',
  billingInfo: '计费信息',
  billingAmount: '计费金额',
  billingRate: '计费汇率',
  billingTime: '计费时间',
  paymentAmount: '扣费金额',
  remark: '备注',
  paymentStatus: '扣费状态',
  paymentTime: '扣费时间',
  shippingFee: '运费',
  operatingFee: '头程操作费',
  packingService: '打包服务费',
  adjustment: '调账补偿',
  noDeductionNow: '暂不扣费',
  adjustmentDeduction: '调账扣费',
  feedbackAndComplaint: '反馈与投诉',
  sellerApp: '卖家App',
  downloadAppleApp: '下载卖家 App，随时管理您的店铺和订单',
  directDownload: '直接下载',
  downloadAppTip: '下载中，请稍后。'
}
